/**
 * Sunucu sayfalama yanıtından tablo sayfa bilgisi. Veri henüz gelmediyse
 * (ilk yükleme) adres çubuğundaki sayfa/boy gösterilir — tablo zıplamaz.
 * Ölçülen tekrar: aynı dört satır dört liste ekranında vardı.
 */

import type { SayfaBilgisi } from '../components/VeriTablosu';

interface SayfaliYanit {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export function sayfaBilgisi(
  veri: SayfaliYanit | undefined,
  sayfaNo: number,
  sayfaBoyu: number
): SayfaBilgisi {
  return {
    page: veri?.page ?? sayfaNo,
    pageSize: veri?.pageSize ?? sayfaBoyu,
    total: veri?.total ?? 0,
    totalPages: veri?.totalPages ?? 1,
  };
}
